import React from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetterSafe } from "../../../../../utils/capitalizeFirstLetterSafe";

export function Row(props) {
  const {
    row,
    setShowModalEditClub,
    setShowModalDeleteClub,
    setSelectedClub,
    setShowModalViewClub,
  } = props;
  const [open, setOpen] = React.useState(false);
  const navigatie = useNavigate();
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.nameRunningClub ?? ""}
        </TableCell>
        <TableCell align="center">
          {row?.trainingDays &&
            row?.trainingDays.map((day, index) => (
              <Typography key={index}>
                {day?.day ?? "Día"}:
                {day?.times &&
                  day.times.map((time) => {
                    return ` ${time} hrs ${index === row?.trainingDays.length - 1 ? "." : ","}`;
                  })}
              </Typography>
            ))}
        </TableCell>
        <TableCell align="center">
          {capitalizeFirstLetterSafe(row?.level) ?? ""}
        </TableCell>
        <TableCell align="center">
          {capitalizeFirstLetterSafe(row?.typeTraining) ?? ""}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setSelectedClub(row);
                    setShowModalEditClub(true);
                  }}
                  startIcon={<SettingsIcon />}
                >
                  Editar Club
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    navigatie(
                      "/dashboard-provider/profile-running-club-provider",
                      { state: { runningClub: row } }
                    );
                  }}
                  startIcon={<VisibilityIcon />}
                >
                  Ver Club
                </Button>
                <Button
                  variant="outlined"
                  color="white"
                  onClick={() => {
                    setSelectedClub(row);
                    setShowModalDeleteClub(true);
                  }}
                  startIcon={<PersonRemoveIcon />}
                >
                  Eliminar Club
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
